import ILookup from '../common/ILookup';
import ISalesHistory from '../sales-history/ISalesHistory';

/**
 * This interface is separate b/c we have keys with spaces in them and it allows us
 * to use "as keyof IBaseFactSheet" when setting the values for these keys.
 * This interface is not the default in this file and should only be used for
 * the above stated purpose.
 * @see IFactSheetProperty
 */
export interface IBaseFactSheet {
    transfer: ILookup<string | number | boolean>;
    'TOTAL Comp Database': ILookup<string | number | boolean>;
    'Your Area MLS': ILookup<string | number | boolean>;
    SmartExchange: ILookup<string | number | boolean>;
    'Public Records': ILookup<string | number | boolean>;
}

/**
 * The fact sheet data for a property.
 * @see IFactSheet
 */
export default interface IFactSheetProperty extends IBaseFactSheet {
    salesHistory?: ISalesHistory;
}

/**
 * Generates an empty instance of IFactSheetProperty
 * @returns
 */
export function newFactSheetProperty(): IFactSheetProperty {
    const result: IFactSheetProperty = {
        transfer: {},
        'TOTAL Comp Database': {},
        'Your Area MLS': {},
        SmartExchange: {},
        'Public Records': {}
    };

    return result;
}
